import MeepoState from './meepo-state';
import MeepoStateEditor from './meepo-state-editor';
import AppAction from './actions/action';
import * as actions from './actions/action-types';

export class MeepoReducer {

    public static reduce(currentState: MeepoState
                             = new MeepoState(), action: AppAction) {
        const meepoStateEditor = new MeepoStateEditor(currentState);
        switch (action.type) {
            case actions.SET_IS_AUTHENTICATED:
                meepoStateEditor.setIsAuthenticated(action.payload.value);
                break;
            case actions.SET_IS_LOADING:
                meepoStateEditor.setIsLoading(action.payload.value);
                break;
            case actions.SET_IS_PROCESS_LOADING:
                meepoStateEditor.setIsProcessLoading(action.payload.value);
                break;
            case actions.SET_USUARIO_PERFIL:
                meepoStateEditor.setUsuarioPerfil(action.payload.value);
                break;
            case actions.SET_RESUMEN_DIARIO_X_RUTA:
                meepoStateEditor.setResumenDiarioXRuta(action.payload.value);
                break;
            default:
                break;
        }
        return meepoStateEditor.commit();
    }
}



// WEBPACK FOOTER //
// ./src/reduxstore/meepo-reducer.ts